import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QrCodeComponent } from '../../components/qr-code/qr-code.component';

@Component({
  selector: 'eng-share-url',
  imports: [QrCodeComponent],
  templateUrl: './share-url.component.html',
  styleUrl: './share-url.component.scss',
})
export class ShareUrlComponent {
  public readonly activeModal = inject(NgbActiveModal);

  public currentUrl = window.location.href;
  public showCopiedText = false;

  public copy() {
    navigator.clipboard.writeText(this.currentUrl);
    this.showCopiedText = true;
    setTimeout(() => {
      this.showCopiedText = false;
    }, 5000);
  }
}
